// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
//import { initializeApp } from 'firebase/app';
import 'firebase/compat/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAieQzkJblTdyZYxm3d-nKXLb5p4J5fdXk',
  authDomain: 'rice-vue-upload.firebaseapp.com',
  databaseURL:
    'https://rice-vue-upload-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'rice-vue-upload',
  storageBucket: 'rice-vue-upload.appspot.com',
  messagingSenderId: '389622858221',
  appId: '1:389622858221:web:c15192db88e0cea70827e4',
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
firebase.initializeApp(firebaseConfig);
export default firebase.database();
